import React from 'react';

const ShareContext = React.createContext({
  inShare: false,
});

export default ShareContext;
